import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { LucideAngularModule, X, Bell, Send } from 'lucide-angular';

@Component({
  selector: 'app-wishlist-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, LucideAngularModule],
  templateUrl: './wishlist-modal.html',
  styleUrl: './wishlist-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistModalComponent {
  private readonly isOpen$$ = new BehaviorSubject<boolean>(false);
  protected readonly isOpen$ = this.isOpen$$.asObservable();

  private readonly featureName$$ = new BehaviorSubject<string>('this feature');
  protected readonly featureName$ = this.featureName$$.asObservable();

  private readonly feedbackType$$ = new BehaviorSubject<string>('general_wishlist');
  protected readonly feedbackType$ = this.feedbackType$$.asObservable();

  @Input()
  set isOpen(value: boolean) {
    this.isOpen$$.next(value);
  }

  @Input()
  set featureName(value: string) {
    this.featureName$$.next(value);
  }

  @Input()
  set feedbackType(value: string) {
    this.feedbackType$$.next(value);
  }

  @Output() readonly closed = new EventEmitter<void>();
  @Output() readonly submitted = new EventEmitter<{ reason: string; feedbackType: string }>();

  protected readonly icons = {
    X,
    Bell,
    Send,
  };

  protected reason = '';

  protected onClose(): void {
    this.reason = '';
    this.closed.emit();
  }

  protected onSubmit(): void {
    this.submitted.emit({ reason: this.reason, feedbackType: this.feedbackType$$.value });
    this.reason = '';
  }
}
